import { createRoute } from '@tanstack/react-router';
import { Suspense, lazy } from 'react';

import 'highlight.js/styles/github-dark.min.css';
import { RootRoute } from '$/routes/RootRoute';

const TechnicalDocsPage = lazy(() =>
  import('$/pages/Documentation/pages/TechnicalDocsPage').then((res) => ({
    default: res.TechnicalDocsPage,
  })),
);

export const TechnicalDocumentationRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/docs/technical',
  component: () => (
    <Suspense>
      <TechnicalDocsPage />
    </Suspense>
  ),
});
